import { Pipe, PipeTransform } from '@angular/core';
import { isObservable, Observable, of } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';
import { DataResponse } from '../../../app/modules/mdr-dashboards/interfaces/mdr-dashboards.data-response.interface';

@Pipe({
    name: 'withLoading',
    standalone: false,
})
export class WithLoadingPipe implements PipeTransform {
    transform(val: Observable<DataResponse>, deep: boolean = false, counter?: number) {
        return isObservable(val)
            ? val.pipe(
                  map((data: DataResponse) => {
                      if (counter) {
                          counter++;
                      }
                      return {
                          loading: false,
                          data: deep ? data.data : data,
                          error: null,
                      };
                  }),
                  startWith({
                      loading: true,
                      data: null,
                      error: null,
                  }),
                  catchError((error) =>
                      of({
                          loading: false,
                          error,
                          data: null,
                      }),
                  ),
              )
            : val;
    }
}
